import React from 'react';
import { BsFillHeartFill } from 'react-icons/bs';
import '../styles/style.css'

export class SiteFooter extends React.Component {
    render () {
        return ((
            <div className="container d-flex flex-row justify-content-between mt-3 text-muted">
                <p className="mt-2 py-2 px-3">
                    Powered by 
                    <a href="https://www.producthunt.com/" target="_blank" rel="noreferrer"> Product Hunt</a>
                    <span> &amp;</span>
                    <a href="https://api.producthunt.com/v2/docs" target="_blank" rel="noreferrer"> Product Hunt API</a>
                </p>
                <p className="mt-2 py-2 px-3">Built with <BsFillHeartFill color="red" />  by <a href="https://twitter.com/manishbharvey" target="_blank" rel="noreferrer">Manish Bharvey</a></p>
            </div>
        ));
    };
};